<template>
  <div class="min-vh main-theme">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} WEBHOOK
      </h1>
      <button v-if="form.id > 0" id="btn-copy" class="create-button " @click="copyValue(form.link)" @mouseout="show = false">
        <font-awesome-icon v-if="copyText == 'Copied'" icon="check-circle" class="text-success" :title="copyText" />
        <font-awesome-icon v-else icon="copy" class="text-ligth" :title="copyText" />
        <span class="ml-2">{{copyText}}</span>
      </button>
      <b-tooltip :show.sync="show" target="btn-copy" placement="bottom">Copied !</b-tooltip>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col>
          <InputText
            textFloat="Code"
            placeholder="Code"
            type="text"
            name="webhookCode"
            v-model="form.code"
            isRequired
            :isValidate="$v.form.code.$error"
            :v="$v.form.code"
          />
        </b-col>
        <b-col>
          <InputText
            textFloat="Name"
            placeholder="Name"
            type="text"
            name="webhookName"
            v-model="form.name"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputTextArea
            type="text"
            textFloat="Description"
            name="webhookDescription"
            rows="3"
            v-model="form.description"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <toggle-button
            class="mt-1 mr-1"
            v-model="form.active"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
          />
          <span class="ml-2 f-size-18 text-header">
            {{ form.active ? "Active" : "Inactive" }}
          </span>
        </b-col>
      </b-row>
      <div class="mt-2 border">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break">API Setting</span>
        </div>
        <div class="p-3">
          <div class="position-relative">
            <b-tabs
              content-class="border m-0 p-3"
              v-model="tabIndex"
            >
              <b-tab title="Body">
                <div>
                  <InputTextArea
                    class="mb-0"
                    type="text"
                    textFloat=""
                    name="body"
                    rows="10"
                    v-model="form.body"
                  />
                </div>
              </b-tab>
              <b-tab title="Response">
                <div>
                  <InputTextArea
                    class="mb-0"
                    type="text"
                    textFloat=""
                    name="response"
                    rows="10"
                    v-model="form.response"
                  />
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/webhook">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5">CANCEL</b-button>
          </router-link>
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import { required, url, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingTime",
  components: {
    InputText,
    InputTextArea,
    InputSelect,
  },
  validations() {
    return {
      form: {
        code: { required },
        name: { required },
      },
    };
  },
  data: function() {
    return {
      isDisabled: false,
      isLoading: false,
      tabIndex: 0,
      id: this.$route.params.id,
      form: {
        id: 0,
        brandId: this.$route.query.brandID,
        code: "",
        name: "",
        description: "",
        body: "",
        response: "",
        active: false
      },
      copyText: "Copy Link",
      show: false
    };
  },
  created: async function() {
    this.isLoading = true;
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    if (this.id) await this.getDetail();
    this.isLoading = false;
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    copyValue(value){
      navigator.clipboard.writeText(value);
      this.show = true;
      this.copyText = "Copied"

      setInterval(() => {
        this.copyText = "Copy Link"
      }, 5000);
    },
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/webhook/${this.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isDisabled = true;
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(`${this.$baseUrl}/webhook/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
    async handleSuccess(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : msg });
      this.$router.push({ path: `/webhook` }).catch(() => {});
    },
    async handleFail(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : msg }); 
    },
  },
};
</script>

<style lang="scss" scoped>
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
